const domain = 'https://devcluster.api.p2g.netd2.hsbc.com.hk/pws-hk-hase-hsvm-papi-sct-proxy/',
      domain2 = 'https://devcluster.api.p2g.netd2.hsbc.com.hk/pws-hk-hase-hsvm2-papi-sct-proxy/',
      domain3 = 'https://hsvm-uat.hsbc.com.hk/cms/ivp/',
      domain4 = 'https://devcluster.api.p2g.netd2.hsbc.com.hk/pws-hk-hase-marketexpress-papi-sct-proxy/',
      version =  'v1/'
export default {
  investor: 'wholesale', //wholesale, institutional
  lang: 'en', // en, sc, zh
  breakpoints: {
    desktop: 992,
    large: 1336 
  },
  customTag: [ '<%', '%>' ],
  endpoints: {
    home: domain + version + 'hsvm/getaemjson/home?type=',
    offeringDoc: domain + version + 'hsvm/resource/offering_doc',
    cropAction: domain + version + 'hsvm/resource/notice_unitholder_doc',
    unlistedFund: domain + version + 'hsvm/unlistedfund/funddetail',
    aboutUs: domain + version + 'hsvm/aem/aboutus',
    insight: {
      index: domain + version + 'hsvm/aem/insightjson/',
      marketCommentary: domain + version + 'hsvm/aem/insightjson/market_commentary/',
      cIOOutlook: domain + version + 'hsvm/aem/insightjson/CIO_outlook/',
      investmentFocus: domain + version + 'hsvm/aem/insightjson/investment_focus/',
      investorEducation: domain + version + 'hsvm/aem/insightjson/investor_education/',
      relatedArticle: domain + version + 'hsvm/aem/insightjson/related/'
    },
    search: domain + version + 'hsvm/search/result/',
    feature_overview: domain2 + version + 'hsvm/fund/feature_overview',
    fund: {
      list: domain2 + version + 'hsvm/aem/fundlist',
      detail: domain2 + version + 'hsvm/aem/funddetail',
      hisprices: domain2 + version + 'hsvm/fund/hisprices',
      lftdandte: domain2 + version + 'hsvm/aem/fund/lftdandte',
      tdandte: domain2 + version + 'hsvm/aem/fund/tdandte',
      performancechart: domain2 + version + 'hsvm/aem/fund/performancechart',
      performancesimulator: domain2 + version + 'hsvm/aem/fund/performancesimulator',
      composition: domain3 + 'hsvm/listed/composition/',
      haseindex:  domain4 + version + 'investment/market-express/haseindex',
      etfinfo:  domain2 + version + 'hsvm/fund/etfinfo'
    }
  }
}